import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceManagementService } from 'src/app/device/device-management.service';
import { UsersService } from 'src/app/users/users.service';
import * as moment from 'moment'
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-replacement-devices-history',
	templateUrl: './replacement-devices-history.component.html',
	styleUrls: ['./replacement-devices-history.component.css']
})
export class ReplacementDevicesHistoryComponent {
	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		replaced_time: TimeSource.PcTime,
	};

	tableColumns: ColumnsConfig[] = [
		{ key: 'replaced_device_sn', name: this.translateService.instant('replace_device.replaced_device_sn'), type: 'link' },
		{ key: 'replaced_device_mac_address', name: this.translateService.instant('replace_device.replaced_device_mac'), type: 'string' },
		{ key: 'replacing_device_sn', name: this.translateService.instant('replace_device.replacing_device_sn'), type: 'link' },
		{ key: 'customer_name', name: this.translateService.instant('g.customer_name'), type: 'link' },
		{ key: 'site_name', name: this.translateService.instant('g.site_name'), type: 'link' },
		{ key: 'replaced_time', name: this.translateService.instant('replace_device.replace_time'), type: 'date_with_ref' },
		{ key: 'user_name', name: this.translateService.instant('replace_device.user_name'), type: 'string' }
	];

	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: false,
		fileName: this.translateService.instant('nav.device_replacement_log'),
		draggable: true,
		csvFileHeaderInfo: []
	};

	tableData: TableData[] = [];

	constructor(
		private router: Router,
		private userService: UsersService,
		private translateService: TranslateService,
		private deviceManagementService: DeviceManagementService,
		private sideMenuService: SideMenuService,
		private commonService: CommonService,
	) {}

	ngOnInit() {
		this.commonService.applyTimeSourceTooltips(this.tableColumns, this.timeSourceByColumn);

		if (!this.userService.hasAccessPermission(null, 'noc'))
			return this.router.navigate(['/unauthorized']);

		this.sideMenuService.hide();
		return this.getReplacementDevicesHistory();
	}

	getReplacementDevicesHistory() {
		this.deviceManagementService.getReplacementDevicesLogs().subscribe((response: any) => {
			const { logs, sites, users, devices } = response;
			const tableData = [];

			logs.forEach(log => {
				const replacedDevice = devices[log.replaced_device_mac_address];
				const replacingDevice = devices[log.replacing_device_mac_address];
				const replacedSite = sites[log.replaced_device_site_id];
				const replacedDeviceSiteInfo = sites[replacedDevice.site_id];
				const replacingSite = replacingDevice ? sites[replacingDevice.site_id] : null;
				const user = users[log.user_id];

				const rowData: TableData = {
					record: log,
					replaced_device_sn: { value: replacedDevice?.serial_number || '', link: replacedDevice && replacedDeviceSiteInfo ? ['/', replacedDeviceSiteInfo.customer_id, replacedDeviceSiteInfo.id, replacedDevice.mac_address, 'performance'] : null },
					replaced_device_mac_address: { value: log.replaced_device_mac_address },
					replacing_device_sn: { value: replacingDevice?.serial_number || '', link: replacingDevice ? ['/', replacingSite?.customer_id, replacingSite?.id, replacingDevice.mac_address, 'performance'] : null },
					customer_name: { value: replacedSite?.customer_name || '', link: replacedSite ? ['/', replacedSite.customer_id] : null },
					site_name: { value: replacedSite?.name || '', link: replacedSite ? ['/', replacedSite.customer_id, replacedSite.id] : null },
					replaced_time: { value: moment(log.created_at).format('MM/DD/YYYY hh:mm:ss a') },
					user_name: { value: user ? `${user.first_name} ${user.last_name}` : this.translateService.instant('users.deleted_user') }
				}
				tableData.push(rowData);
			});
			this.tableData = tableData;
		});
	}
}
